// Attribution intents
export const SIGN_UP_INTENT = 'sign_up_modal';
export const SIGN_UP_OTP_INTENT = 'sign_up_otp_modal';
export const LOGIN_EMAIL_INTENT = 'login_email_modal';
export const LOGIN_MOBILE_INTENT = 'login_mobile_modal';
export const LOGIN_MOBILE_OTP_INTENT = 'login_mobile_otp_modal';

// Authentication error Messages
// eslint-disable-next-line max-len
export const CONFIRM_EMAIL_ERROR = 'Email unconfirmed. Please confirm your Email.';
